export default __webpack_public_path__ + "static/media/icon.9dd1202e.png";